module.exports = __webpack_public_path__ + "static/img/img_serve4.455280e8.png";